"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
function onFinish() {}
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Form, {
    name: "basic",
    labelCol: {
      span: 8
    },
    wrapperCol: {
      span: 16
    },
    initialValues: {
      remember: true
    },
    onFinish: onFinish,
    autoComplete: "off"
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Username",
    name: "username",
    status: 'warning',
    rules: [{
      required: true,
      message: 'Please input your username!'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, null)));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorWarning'],
  key: 'warning'
};
var _default = exports.default = componentDemo;